import { Lightning } from '@lightningjs/sdk';
import { CmsConstants } from '../../Business/cms/CmsConstants';
import { Theme } from '../../config/theme';

export class CmsProgress extends Lightning.Component {
  static _template() {
    const dims = CmsConstants.Progress;
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: dims.height,
      Unfilled: {
        rect: true,
        x: dims.horizontalPadding,
        y: dims.verticalPadding,
        w: w => w - dims.horizontalPadding - dims.horizontalPadding,
        h: dims.height - dims.verticalPadding - dims.verticalPadding,
        color: Theme.Colors.CmsProgress.Unfilled,
      },
      Fill: {
        rect: true,
        x: dims.horizontalPadding,
        y: dims.verticalPadding,
        w: 0,
        h: dims.height - dims.verticalPadding - dims.verticalPadding,
        color: Theme.Colors.CmsProgress.Filled,
      },
    };
  }

  _build() {
    this.fillPercentage = 0;
  }

  set fillPercentage(val) {
    const v = Math.min(1, Math.max(0, val));
    this.stage.update();
    this.tag('Fill').w = this.tag('Unfilled').finalW * v;
  }
}
